module.exports = __webpack_public_path__ + "static/media/ic-arrow-left.3cf20f0d.svg";